import Vue from 'vue';
import Vuex from 'vuex';
import {auth} from 'firebase/app';
import router from './router';

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    currentUser: null,
    authenticated: false,
    events: [],
    crewMembers: [],
    positions: []
  },
  actions: {
    userSignOut({commit}) {
      auth()
        .signOut()
        .then(() => {
          commit('setCurrentUser', null);
          commit('setIsAuthenticated', false);

          router.push('/');
        });
    }
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val;
    },
    setIsAuthenticated(state, val) {
      state.authenticated = val;
    },
    addEvent(state, val) {
      let match = false;
      for (const event of state.events) {
        if (event.title === val.title && event.date === val.date) {
          match = true;
        }
      }

      if (match === false) {
        state.events.push(val);
      }
    },
    removeEvent(state, val) {
      let event;
      for (const e of state.events) {
        if (e.id === val) {
          event = e;
        }
      }

      const index = state.events.indexOf(event);
      if (index > -1) {
        state.events.splice(index, 1);
      }
    },
    addCrewMember(state, val) {
      let match = false;
      for (const member of state.crewMembers) {
        if (member.name === val.name && member.email.toLowerCase() === val.email.toLowerCase()) {
          match = true;
        }
      }
      if (match === false) {
        state.crewMembers.push(val);
      }
    },
    addPosition(state, val) {
      let match = false;
      for (const position of state.positions) {
        if (position.title === val.title) {
          match = true;
        }
      }

      if (match === false) {
        state.positions.push(val);
      }
    },
    removePosition(state, val) {
      let position;
      for (const pos of state.positions) {
        if (pos.id === val) {
          position = pos;
        }
      }

      const index = state.positions.indexOf(position);
      if (index > -1) {
        state.events.splice(index, 1);
      }
    }
  },
  getters: {
    events(state) {
      return state.events;
    },
    crewMembers(state) {
      return state.crewMembers;
    },
    isLoggedIn(state) {
      return state.authenticated && state.currentUser !== undefined;
    }
  }
});

export default store;
